import {
  ITicketReceiveState,
  ShareStatus,
  IRecipientTicketInfo,
  IError
} from "src/client/interface/IShareInfo";
import {
  LoadTicketReceivingDataActions,
  TicketReceivingActionTypes
} from "./actions";

const initState: ITicketReceiveState = {
  loading: false,
  data: undefined,
  error: undefined,
  checkReceive: true,
  postStep: "",
  firstAccepted: false
};

export const ticketReceiveReducer = (
  state: ITicketReceiveState = initState,
  action: LoadTicketReceivingDataActions
) => {
  switch (action.type) {
    case TicketReceivingActionTypes.LOAD_TICKET_RECEIVING_DATA_PENDING: {
      return {
        ...state,
        error: null as IError,
        loading: true,
        firstAccepted: false
      };
    }

    case TicketReceivingActionTypes.LOAD_TICKET_RECEIVING_DATA_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null as IError,
        data: action.payload
      };
    }

    case TicketReceivingActionTypes.LOAD_TICKET_RECEIVING_DATA_FAILED: {
      const currentData = ({
        shareStatus: ShareStatus.Init
      } as unknown) as IRecipientTicketInfo;
      return {
        ...state,
        data: currentData,
        loading: false,
        error: action.error
      };
    }

    case TicketReceivingActionTypes.UPDATE_CHECKRECEIVE_STATUS: {
      return {
        ...state,
        checkReceive: action.payload
      };
    }

    case TicketReceivingActionTypes.UPDATE_POST_STEP: {
      return {
        ...state,
        postStep: action.payload
      };
    }

    case TicketReceivingActionTypes.ACCEPT_TICKET_PENDING: {
      return {
        ...state,
        error: null,
        loading: true,
        firstAccepted: false
      };
    }

    case TicketReceivingActionTypes.ACCEPT_TICKET_FAILED: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }

    case TicketReceivingActionTypes.ACCEPT_TICKET_SUCCESS: {
      const currentData = JSON.parse(JSON.stringify(state.data));
      currentData.shareStatus = ShareStatus.Accepted;
      return {
        ...state,
        data: currentData,
        postStep: "",
        loading: false,
        error: null as IError,
        firstAccepted: true
      };
    }

    case TicketReceivingActionTypes.DECLINE_TICKET_PENDING: {
      return {
        ...state,
        error: null,
        loading: true,
        firstAccepted: false
      };
    }

    case TicketReceivingActionTypes.DECLINE_TICKET_FAILED: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }

    case TicketReceivingActionTypes.DECLINE_TICKET_SUCCESS: {
      const currentData = JSON.parse(JSON.stringify(state.data));
      currentData.shareStatus = ShareStatus.Rejected;
      return {
        ...state,
        data: currentData,
        postStep: "",
        loading: false,
        error: null as IError
      };
    }

    default: {
      return state;
    }
  }
};
